<template>
  <div class="language-wap">
    <div class="language-container">
      <div class="country-warp">
        <img :src="require('@/assets/flag/icon-flag-' + nowLanguage.code + '.png')" width="24" height="24">
        {{ nowLanguage.native }}
      </div>
      <img :src="require('@/assets/ico-chevron-down-bg.png')" width="28" height="28" @click="openSelectLanguage">
    </div>

    <div class="sublanguage" v-if="isShow" ref="langDiv">
      <div class="country-warp sub" v-for="item in language" :key="item" @click="changeLanguage(item)">
        <img :src="require('@/assets/flag/icon-flag-' + item.code + '.png')" width="24" height="24">
        {{ item.native }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, onUnmounted } from 'vue'
import { strUtil } from '@/utils'
import { useI18n } from 'vue-i18n';
import { useBaseStore } from '@/stores/base'
const baseStore = useBaseStore()

const nowLanguage = ref({ country: '한국', native: '한국어', code: 'ko' })
const { t, locale } = useI18n();
const isShow = ref(false)
const langDiv = ref(null)

const language = ref([
  { country: '한국', native: '한국어', code: 'ko' },
  { country: '미국', native: 'English', code: 'en' },
  // { country: '베트남', native: 'Tiếng Việt', code: 'vi' },
  // { country: '러시아', native: 'Русский', code: 'ru' },
  // { country: '우즈베키스탄', native: 'Oʻzbekcha', code: 'uz' },
  // { country: '중국', native: '中文', code: 'zh' },
  // { country: '아랍에미리트', native: 'العربية ', code: 'ar' },
  // { country: '스페인', native: 'Español', code: 'es' },
  // { country: '인도네시아', native: 'Bahasa Indonesia', code: 'id' },
  // { country: '포르투갈', native: 'Português', code: 'pt' },
  // { country: '프랑스', native: 'Français', code: 'fr' }
])

const openSelectLanguage = () => {
  isShow.value = true;
}

const changeLanguage = (language) => {
  baseStore.setLanguage(language)
  nowLanguage.value = language
  locale.value = language.code
  isShow.value = false;
}

onMounted(() => {
  if (strUtil.isEmpty(baseStore.getLanguage)) {
    baseStore.setLanguage({ country: '한국', native: '한국어', code: 'ko' })
  }
  document.addEventListener('mousedown', handleClickOutsideLang);
  window.addEventListener('keydown', handleKeyDown);

  nowLanguage.value = baseStore.getLanguage
  locale.value = baseStore.getLanguage.code
})

onUnmounted(() => {
  document.removeEventListener('mousedown', handleClickOutsideLang);
  window.removeEventListener('keydown', handleKeyDown);
});

const handleClickOutsideLang = (event) => {
  if (isShow.value && !langDiv.value.contains(event.target)) {
    isShow.value = false;
  }
}
const handleKeyDown = (event) => {
  if (event.key === 'Escape') {
    isShow.value = false;
  }
}
</script>
<style lang="scss" scoped>
@import '@/sass/app.scss';

.language-wap {
  position: relative;
}

.sublanguage {
  position: absolute;
  padding: 12px 12px;
  box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.12);
  border-radius: 16px;
  background-color: #fff;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 12px;
  box-sizing: border-box;
  gap: 10px;
  text-align: left;
  font-size: 16px;
  color: #000;
  font-family: 'Pretendard GOV';
  z-index: 2;
}

.language-container {
  position: relative;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.06);
  border-radius: 50px;
  background-color: #fff;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 6px 6px 6px 12px;
  box-sizing: border-box;
  gap: 20px;
  text-align: left;
  font-size: 16px;
  color: #000;
}

.country-warp {
  display: flex;
  width: 100%;
  align-items: center;
  position: relative;
  flex-direction: row;
  letter-spacing: -0.4px;
  gap: 8px;
  line-height: 14px;
  font-weight: 500;
}

.sub:hover {
  background-color: aqua;
}
</style>
